<template>
  <div>
    <!-- <column-title :title="title" :desc="desc" /> -->
    <div class="policy" v-if="newsListRes.length > 0">
      <swiper :options="isPc == 1 ? swiperOption3 : swiperOption1" ref="mySwiper">
        <swiper-slide v-for="item in newsListRes" :key="item.newsId">
          <div class="policy-item hand" @click="toDetails(item)">
            <img :src="item.newsImage" />
            <div class="info">
              <!-- <div class="flex-col items-center justify-between">
                <span class="bg-red text-white font20">
                  {{ item.newstype }}
                </span>
                <time class="text-grey font14">{{ item.releaseTime }}</time>
              </div> -->
              <h3>{{ item.newsTitle }}</h3>
              <div class="tag">{{ item.tag }}</div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-button-prev2 items-center justify-center hand">
        <svg-icon icon-class="arrow" color="rgba(0, 0, 0, 0.4)" hoverColor="#2C2C2E"></svg-icon>
      </div>
      <div class="swiper-button-next2 items-center justify-center hand">
        <svg-icon icon-class="arrow" color="rgba(0, 0, 0, 0.4)" hoverColor="#2C2C2E"></svg-icon>
      </div>
      <!-- <router-link :to="{ path: `/article?typeId=${typeId}` }">
        <div
          class="more bg-white min-main border-black items-center justify-between"
        >
          <div></div>
          <h3 class="font16">{{ moreText }}</h3>
          <svg-icon icon-class="Path 2492"></svg-icon>
        </div>
      </router-link> -->
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import columnTitle from "./column-title.vue";
import { getNewsList } from "@/assets/api/news.js";

import { mapState } from "vuex";
export default {
  components: {
    swiper,
    swiperSlide,
    columnTitle,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    desc: {
      type: String,
      default: "",
    },
    moreText: {
      type: String,
      default: "更多",
    },
    typeId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      newsListRes: [],
      swiperOption1: {
        slidesPerView: 1, //一页显示几个
        spaceBetween: 16, //每一个之间的距离
        slidesOffsetBefore: 0, //距离左边的距离
        slidesOffsetAfter: 0, //距离右边的距离
        centeredSlides: true,
        loop: true,
        speed: 1000,
        autoplay: {
          delay: 30000, //自动切换的时间间隔
          pauseOnMouseEnter: true, //鼠标置于swiper时暂停自动切换，鼠标离开时恢复自动切换。
        },
        navigation: {
          nextEl: ".swiper-button-next2", //前进按钮的css选择器或HTML元素。
          prevEl: ".swiper-button-prev2", //后退按钮的css选择器或HTML元素。
          hideOnClick: true, //点击slide时显示/隐藏按钮
          disabledClass: "my-button-disabled2", //前进后退按钮不可用时的类名。
          hiddenClass: "my-button-hidden2", //按钮隐藏时的Class
        },
      },
      swiperOption2: {
        slidesPerView: 2, //一页显示几个
        spaceBetween: 16, //每一个之间的距离
        slidesOffsetBefore: 0, //距离左边的距离
        slidesOffsetAfter: 0, //距离右边的距离
        centeredSlides: true,
        loop: true,
        speed: 1000,
        autoplay: {
          delay: 30000, //自动切换的时间间隔
          pauseOnMouseEnter: true, //鼠标置于swiper时暂停自动切换，鼠标离开时恢复自动切换。
        },
        navigation: {
          nextEl: ".swiper-button-next2", //前进按钮的css选择器或HTML元素。
          prevEl: ".swiper-button-prev2", //后退按钮的css选择器或HTML元素。
          hideOnClick: true, //点击slide时显示/隐藏按钮
          disabledClass: "my-button-disabled2", //前进后退按钮不可用时的类名。
          hiddenClass: "my-button-hidden2", //按钮隐藏时的Class
        },
      },
      swiperOption3: {
        slidesPerView: 3.5, //一页显示几个
        spaceBetween: 20, //每一个之间的距离
        slidesOffsetBefore: 40, //距离左边的距离
        slidesOffsetAfter: -40, //距离右边的距离
        // centeredSlides: true,
        loop: true,
        speed: 1000,
        autoplay: {
          delay: 3000, //自动切换的时间间隔
          pauseOnMouseEnter: true, //鼠标置于swiper时暂停自动切换，鼠标离开时恢复自动切换。
        },
        navigation: {
          nextEl: ".swiper-button-next2", //前进按钮的css选择器或HTML元素。
          prevEl: ".swiper-button-prev2", //后退按钮的css选择器或HTML元素。
          hideOnClick: true, //点击slide时显示/隐藏按钮
          disabledClass: "my-button-disabled2", //前进后退按钮不可用时的类名。
          hiddenClass: "my-button-hidden2", //按钮隐藏时的Class
        },
      },
    };
  },
  computed: {
    ...mapState(["isPc"]),
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      getNewsList({
        orderByColumn: "releaseTime",
        isAsc: "desc",
        typeId: this.typeId,
        pageNum: 1,
        pageSize: 6,
        slideshow: 0,
      }).then((res) => {
        // console.log(res.data);
        this.newsListRes = res.data.rows.map((item) => {
          item.newsImage = !/^http/.test(item.newsImage)
            ? this.$imgUrl + item.newsImage
            : item.newsImage;
          item.tag = item.tag.split('|').join(' · ');
          return item;
        });
      });
    },
    changeSize(e) {
      console.log(e);
      this.pageNum = e;
      this.init();
    },
    generateSlug(title) {
      // 将标题中的空格替换为连字符
      let slug = title.toLowerCase().replace(/\s+/g, '-');
      // 将连字符替换为单个连字符
      slug = slug.replace(/-+/g, '');
      slug = slug.replace(/:+/g, '');
      return slug;
    },
    toDetails(item) {
      if (item.url) {
        window.open(item.url, "_blank");
      } else {
        localStorage.setItem('newsId', item.newsId);
        let path = item.seoUrl ? item.seoUrl : item.newsId
        this.$router.push({
          path: `/${path}.html`,
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.policy {
  position: relative;
  padding-bottom: 40px;

  .policy-item {
    font-size: 0;

    img {
      width: 100%;
      height: 193px;
      border-radius: 8px;
      object-fit: cover;
    }

    span {
      padding: 10px 30px;
      font-family: NotoSansCJKTC;
      font-size: 20px;
      font-weight: bold;
      line-height: 28px;
      letter-spacing: 1px;
      margin-top: -24px;
      margin-bottom: 8px;
    }

    time {
      font-family: NotoSansCJKTC;
      font-weight: bold;
      line-height: 1.71;
      letter-spacing: 0.7px;
    }

    h3 {
      font-family: MicrosoftYaHei, MicrosoftYaHei;
      font-weight: bold;
      font-size: 18px;
      color: #2C2C2E;
      line-height: 24px;
      text-align: left;
      font-style: normal;
      margin-top: 12px;
      margin-bottom: 6px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-break: break-all;
    }

    .tag {
      font-family: MicrosoftYaHei;
      font-size: 14px;
      color: #AEAEB2;
      line-height: 19px;
      text-align: left;
      font-style: normal;
    }

    &:hover {
      h3 {
        color: #E2291E;
      }
    }
  }

  .more {
    padding: 10px 30px;
    box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.16);
    border-width: 2px;
    border-radius: 45px;
    margin-top: 33px;

    h3 {
      font-family: NotoSansCJKTC;
      font-size: 16px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: 0.8px;
      color: #630106;
    }

    .svg-icon {
      width: 5.1px;
      height: 10.1px;
    }
  }
}

@media screen and (max-width: 768px) {
  .policy {
    position: relative;
    padding-bottom: 0;
    margin: 0 10px;

    .policy-item {
      font-size: 0;

      img {
        width: 100%;
        height: 239px;
        object-fit: cover;
      }

      span {
        margin-bottom: 3px;
      }

      h3 {
        padding: 0 17px;
        padding-bottom: 15px;
      }
    }

    .min-main {
      width: 100%;
    }

    .more {
      padding: 10px 30px;
      box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.16);
      border-width: 2px;
      border-radius: 20px;
      margin-top: 15px;

      h3 {
        font-family: NotoSansCJKTC;
        font-size: 16px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: 0.8px;
        color: #630106;
      }

      .svg-icon {
        width: 5.1px;
        height: 10.1px;
      }
    }
  }
}
</style>
<style>
.swiper-button-prev2,
.swiper-button-next2 {
  position: absolute;
  left: -20px;
  top: 100px;
  z-index: 999;
  width: 40px;
  height: 40px;
  background: #FFFFFF;
  border: 1px solid #E5E5EA;
  border-radius: 50%;
  transform: rotate(180deg);

  .svg-icon {
    width: 16px;
    height: 16px;
    color: rgba(0, 0, 0, 0.4);
  }

  &:hover {
    background-color: #E2291E;
    border-color: #E2291E;

    .svg-icon {
      color: #FFFFFF !important;
    }
  }
}

.swiper-button-next2 {
  left: auto;
  right: -20px;
  transform: rotate(0deg);
}

.swiper-slide-prev {
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
}

/* .swiper-slide-active{
  opacity: 1;
  transition: opacity 0.5s ease-in-out;
} */


@media screen and (max-width: 768px) {

  .swiper-button-prev2,
  .swiper-button-next2 {
    position: absolute;
    z-index: 9;
    left: -10px;
    top: 80px;
    width: 30px;
    height: 80px;
  }

  .swiper-button-next2 {
    left: auto;
    right: -10px;
  }

  .swiper-button-prev2 .svg-icon,
  .swiper-button-next2 .svg-icon {
    width: 30px !important;
    height: 80px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/common/swiper-policy.vue